import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from 'dashboard/helper/URLHelper';
import SettingsContent from '../Wrapper.vue';
import SettingsWrapper from '../SettingsWrapper.vue';
import BotFlows from './Index.vue';
import BotFlowEditor from './BotFlowEditor.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/bot-flows'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'bot_flows_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'bot_flows_list',
          component: BotFlows,
          meta: {
            featureFlag: FEATURE_FLAGS.BOT_FLOWS,
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/bot-flows'),
      component: SettingsContent,
      props: () => {
        return {
          headerTitle: 'BOT_FLOWS.EDITOR.HEADER',
          icon: 'flow',
          showBackButton: true,
        };
      },
      children: [
        {
          path: ':botFlowId/edit',
          name: 'bot_flows_edit',
          component: BotFlowEditor,
          meta: {
            featureFlag: FEATURE_FLAGS.BOT_FLOWS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'new',
          name: 'bot_flows_new',
          component: BotFlowEditor,
          meta: {
            featureFlag: FEATURE_FLAGS.BOT_FLOWS,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
